import React, { useMemo } from 'react';
import classNames from 'classnames';
import PdfIcon from 'icons/Pdf.icon';
import ProgressBar from 'components/ProgressBar';
import { Button } from 'ncoded-component-library';
import XIcon from 'icons/X.icon';
import { formatPercentage } from 'utils';
import { useTranslation } from 'react-i18next';

import './FileUploader.styles.scss';

export type FileUploaderProps = {
  className?: string;
  name: string;
  size: number;
  percentage: number;
  isPending?: boolean;
  icon?: React.FC;
  onXClick?: () => void;
};

const FileUploader: React.FC<FileUploaderProps> = (props) => {
  const {
    className,
    name,
    size,
    percentage,
    isPending,
    icon: Icon = PdfIcon,
    onXClick,
  } = props;

  const { t } = useTranslation();

  const classes = classNames('file-uploader', className);

  const sizeInKb = useMemo(() => (size / (2 << 9)).toFixed(2), [size]);

  return (
    <div className={classes}>
      {onXClick && (
        <Button
          className="x-button"
          aria-label="Close"
          icon={XIcon}
          onClick={onXClick}
        />
      )}
      <Icon />
      <span className="text--title">{name}</span>
      <ProgressBar
        className="file-uploader__progress-bar"
        percentage={percentage}
      />
      <span className="text--percentage">
        {isPending ? (
          t('waitingForUpload')
        ) : (
          <>
            {t('uploading')}&nbsp;{formatPercentage(percentage)}
          </>
        )}
      </span>
      <span className="text--size">{`of ${sizeInKb} KB`}</span>
    </div>
  );
};

export default FileUploader;
